const NAMESPACE = 'POLICIES';

const SET_ALL_POLICIES = `${NAMESPACE}/SET_ALL_POLICIES`;
const SET_POLICY = `${NAMESPACE}/SET_POLICY`;

export {
    SET_ALL_POLICIES,
    SET_POLICY,
};

export default NAMESPACE;
